import { IonButton, IonCheckbox, IonContent, IonIcon, IonInput, IonItem, IonLabel, IonPopover, IonRadio, IonRadioGroup } from '@ionic/react';
import { chevronBack, chevronDown, close, closeOutline, filterOutline, options, search } from 'ionicons/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, Sectiontitle, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import NoFilterResults from '../../components/noFilterResults';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { capitalize, deepCopy, forwardTo, isDefined, isEmptyObject, makeKey, openExternalLink, parseAllergenData } from '../../lib/utils';
import { setDeliveryOption, setScrollTop } from '../../store/actions';
import { ItemDetailsRaw } from '../itemDetails';
import '../order/index.css';
import { OrderSummary } from '../orderSummary';
import './index.css';
import OrderList from './orderList';
import ScrollableTabs from '../../components/scrollTabs';

const { validateItem, getProductName, getProductDescription, _calculateItemPrice, formatPrice, addToBasket, isChoicesGroupValid } = Basket;

const defaultModalItemOptions = {
	quantity: 1,
	price: 0,
	selectedChoices: [],
	instructions: '',
};

// category menu calc
const rowHeight = 41; // <-- within error of 1 or 2 pixels
const topOffset = 50;

class OrderPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedCategory: 0,
			ikentooMenu: null,
			originalMenu: null,
			searchItemsValue: '',
			menuRefs: null,
			categoriesPositionTop: [],
			modalOpen: false,
			modalItem: null,
			modalItemOptions: defaultModalItemOptions,
			validationErrors: [],
			showValidationAlert: false,
			previousRowNum: 1,
			menuHero: '',
			title: '',
			description: '',
			mainLogo: '',
			nameVisible: true,
			categoryHeight: 0,
			allergens: [],
			categoryDropdownVisible: false,
			activeSegment: 1,
			filterModalOpen: false,
			selectedDietary: [],
			selectedAllergens: [],
			draftDietary: [],
			draftAllergens: []


		};
		this.listRef = React.createRef();
		this.resizeObserver = null;
		this.scrollableWrapperRef = React.createRef()
		this.selectCategoryOnScroll = this.selectCategoryOnScroll.bind(this);
	}

	setIkentooMenu = (menu) => {
		let ikentooMenu = this.props.defaultMenu;
		let originalMenu = this.props.defaultMenu;
		if (!isEmptyObject(this.props.ikentooMenu) && Basket.getOrderType() && (!isEmptyObject(Basket.getRestaurant()) || Basket.curated_menu)) {
			ikentooMenu = this.props.ikentooMenu;
			originalMenu = this.props.ikentooMenu;
		}
		this.setState({ ikentooMenu, originalMenu },
			() => {
				let menuRefs = this.menuRefs(this.state.ikentooMenu);
				this.setState({ menuRefs });
				if (this.state.searchItemsValue || this.hasSelectedFilters()) {
					this.filterMenuItems(this.state.searchItemsValue)
				}
			},
		);
	};
	setDeliveryOption = (delivery) => {
		this.props.dispatch(setDeliveryOption(delivery));
		Basket.setDeliveryOption(delivery);
		Basket.setOrderType(delivery.id);
		forwardTo(
			delivery.id === 'delivery'
				? '/delivery'
				: delivery.id === 'charter-delivery'
					? '/delivery'
					: delivery.id === 'pick-up-point'
						? '/pick-up-point'
						: delivery.id === 'table'
							? '/order-to-table'
							: '/click-and-collect',
			{ isLogoClicked: false },
		);
	};

	onWindowResize = () => {
		setTimeout(() => {
			const catMenu = document.querySelector('.order-categories-inner');
			if (catMenu) {
				const rowNum = Math.round(catMenu.clientHeight / rowHeight);
				if (rowNum !== this.state.previousRowNum) {
					this.setState({ previousRowNum: rowNum });
					const subHeaders = document.querySelectorAll('.order-sublist-header');
					subHeaders.forEach((item) => (item.style.top = topOffset + rowNum * rowHeight + 'px'));
				}
			}
		}, 0);
	};
	componentDidUpdate(prevProps, prevState) {
		if (this.state.categoryHeight !== document.querySelector('.order-categories')?.clientHeight) {
			this.setState({ categoryHeight: document.querySelector('.order-categories')?.clientHeight });
		}
	}
	componentDidMount() {
		const { clientProfile } = this.props;
		this.setIkentooMenu();
		window.addEventListener('resize', this.onWindowResize, false);
		setTimeout(() => {
			this.onWindowResize();
			const item = document.querySelector('.no-padding');
			if (item) {
				item.scrollTop = this.props.scrollTop;
				item.scrollBy({ top: 1, behavior: 'smooth' });
			}
		}, 1500);
		this.setState({
			menuHero: clientProfile.hero_image,
			title: clientProfile.buisiness_name,
			description: clientProfile.buisiness_description,
			mainLogo: clientProfile.logo_image,
		});

	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
	}

	shouldComponentUpdate(nextProps) {
		if (this.props.clientProfileUpdated !== nextProps.clientProfileUpdated) {
			this.setState({
				menuHero: nextProps.clientProfile.hero_image,
				title: nextProps.clientProfile.buisiness_name,
				description: nextProps.clientProfile.buisiness_description,
			});
		}
		const prevMenuName = (Basket.items.length === 0 && isEmptyObject(this.props.ikentooMenu) ? nextProps.defaultMenu : nextProps.ikentooMenu || {}).menuName;
		const currentMenuName = (Basket.items.length === 0 && isEmptyObject(this.props.ikentooMenu) ? this.props.defaultMenu : this.props.ikentooMenu || {}).menuName;
		if (prevMenuName !== currentMenuName || nextProps.restaurantsUpdated !== this.props.restaurantsUpdated) {
			this.setIkentooMenu();
		}
		return true;
	}

	menuRefs = (menuRefs) => {
		return menuRefs && menuRefs.menuEntryGroups
			? menuRefs.menuEntryGroups.reduce((acc, value, index) => {
				let name = value.name + '_' + index;
				acc[name] = React.createRef();
				return acc;
			}, {})
			: {};
	};

	scrollTo = (name) => {
		let categoryHeightHeading = document.querySelector('.order-list-heading');
		let categoryHeightHeadingHeight = 0;
		if (categoryHeightHeading) {
			categoryHeightHeadingHeight = categoryHeightHeading.clientHeight;
		}
		document.querySelector('.no-padding').scroll({
			top: this.state.menuRefs[name].current.offsetTop + categoryHeightHeadingHeight,
			behavior: 'smooth',
		});
	};

	selectCategoryOnScroll = (e) => {
		e.preventDefault();
		const headingInfo = document.querySelector('.order-list-restaurant-image');
		const positionTop = headingInfo && e.target.scrollTop - headingInfo.clientHeight > 0 ? e.target.scrollTop - headingInfo.clientHeight : e.target.scrollTop;
		const { menuRefs } = this.state;
		setTimeout(() => {
			const positions = Object.keys(menuRefs).map((key) => {
				if (!menuRefs[key].current) {
					return null;
				}
				return menuRefs[key].current.offsetTop;
			});
			let selectCategory = 0;
			positions.forEach((item, i) => {
				if (item <= positionTop + 350) {
					selectCategory = i;
				}
			});
			this.props.dispatch(setScrollTop(positionTop));
			this.setState({ selectedCategory: selectCategory });
		}, 150);
	};

	showModal = (modalItem) => {
		this.setState(
			{
				modalItem,
				modalItemOptions: {
					...this.state.modalItemOptions,
					price: _calculateItemPrice({ item: modalItem, quantity: 1 }),
					selectedChoices: modalItem.menuDealGroups && modalItem.menuDealGroups.length ? Array(modalItem.menuDealGroups.length).fill([]) : [],
					validationErrors: modalItem.menuDealGroups && modalItem.menuDealGroups.length ? Array(modalItem.menuDealGroups.length).fill(null) : [],
				},
				modalOpen: true,
			},
			() => {
				setTimeout(() => {
					const splitPane = document.querySelector('ion-split-pane');
					if (splitPane) {
						splitPane.classList.add('blur');
					}
				}, 300);
			},
		);
	};

	handleInputChange = (groupIndex, choiceIndex, multiSelectionPermitted, event) => {
		const item = this.state.modalItem;
		const { selectedChoices, quantity } = this.state.modalItemOptions;
		const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
		const selectedGroup = allGroups[groupIndex];
		if (selectedGroup) {
			const selectedChoice = selectedGroup.items[choiceIndex];
			let updatedSelectedChoices = deepCopy(selectedChoices);
			if (multiSelectionPermitted) {
				//checkbox
				if (event.target.checked) {
					updatedSelectedChoices[groupIndex].push(selectedChoice);
				} else {
					updatedSelectedChoices[groupIndex] = updatedSelectedChoices[groupIndex].filter((i) => i.sku !== selectedChoice.sku);
				}
			} else {
				//radio
				if (!selectedChoice) {
					updatedSelectedChoices[groupIndex] = [];
				} else {
					updatedSelectedChoices[groupIndex] = [selectedChoice];
				}
			}

			this.setState(
				{
					modalItemOptions: {
						...this.state.modalItemOptions,
						selectedChoices: updatedSelectedChoices,
					},
				},
				() => {
					const { selectedChoices } = this.state.modalItemOptions;
					//recalculate item price on every menu deal choice change
					this.setState({ price: _calculateItemPrice({ item, quantity, selectedChoices }) }, () => {
						const validationErrors = validateItem(this.constructBasketItem());
						this.setState({ validationErrors: validationErrors.errors });
					});
				},
			);
		}
	};

	drawGroupChoices = (choices = [], multiSelectionPermitted, groupIndex) => {
		const { selectedChoices } = this.state.modalItemOptions;
		const { profile, __ } = this.props;
		const allChoices = choices.map((item, choiceIndex) => {
			const { sku, productPrice } = item;
			const isChecked = !!(selectedChoices[groupIndex] || []).find((i) => i.sku === sku);
			return (
				<IonItem lines="none" key={makeKey(choiceIndex, sku, groupIndex)}>
					<div tabIndex="-1"></div>
					{multiSelectionPermitted ? (
						<IonCheckbox
							color="primary"
							slot="start"
							checked={isChecked}
							onIonChange={(event) => {
								this.handleInputChange(groupIndex, choiceIndex, multiSelectionPermitted, event);
							}}
						/>
					) : (
						<IonRadio slot="start" className="details-radio" color="primary" value={choiceIndex} checked={isChecked} />
					)}
					<IonLabel className="ion-text-wrap">
						<Sectiontitle >{__(getProductName(item, profile))}</Sectiontitle>
						{getProductDescription(item, profile) ? <SmallText className="no-margin">{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText> : null}
					</IonLabel>
					<p>{formatPrice(productPrice)}</p>
				</IonItem>
			);
		});
		if (multiSelectionPermitted) {
			return allChoices;
		} else {
			//radio
			return (
				<IonRadioGroup
					onIonChange={(event) => {
						this.handleInputChange(groupIndex, event.target.value, multiSelectionPermitted, event);
					}}
				>
					{allChoices}
				</IonRadioGroup>
			);
		}
	};

	drawGroupLabel = (label, groupIndex) => {
		const { validationErrors } = this.state;
		const { __ } = this.props;

		return (
			<>
				<IonItem>
					<div className="sectiontitle">{label}</div>
				</IonItem>
				{validationErrors[groupIndex] ? <div className="field-error">{__(validationErrors[groupIndex])}</div> : null}
			</>
		);
	};

	drawMenuDealGroups = (menuGroupItem, index) => {
		// multiSelectionPermitted = true  --> only one item must be selected
		const multiSelectionPermitted = menuGroupItem.multiSelectionPermitted;
		if (isChoicesGroupValid(menuGroupItem)) {
			if (isDefined(multiSelectionPermitted)) {
				return (
					<div key={index}>
						{this.drawGroupLabel(menuGroupItem.description, index)}
						{this.drawGroupChoices(menuGroupItem.items, multiSelectionPermitted, index)}
					</div>
				);
			} else {
				return this.drawGroupLabel(menuGroupItem.description);
			}
		}
	};

	constructBasketItem = () => {
		const { modalItem, modalItemOptions } = this.state;
		const { quantity, selectedChoices, instructions } = modalItemOptions;
		let constructModel = {};
		if (modalItem) {
			constructModel = {
				item: modalItem,
				quantity,
				selectedChoices,
				instructions,
			};
		}
		return constructModel;
	};

	onIncrementerUpdate = (newQuantity) => {
		const price = _calculateItemPrice({
			item: this.state.modalItem,
			quantity: newQuantity,
			selectedChoices: this.state.modalItemOptions.selectedChoices,
		});
		this.setState({
			modalItemOptions: { ...this.state.modalItemOptions, quantity: newQuantity, price },
		});
	};

	addToOrder = () => {
		const newBasketItem = this.constructBasketItem();
		const validationErrors = validateItem(newBasketItem);
		if (validationErrors.errorCount > 0) {
			this.setState({ validationErrors: validationErrors.errors });
			this.setState({ validationErrors: validationErrors.errors }, () => {
				this.setShowValidationAlert(true);
			});
		} else {
			addToBasket(newBasketItem);
			this.setState({
				modalItem: null,
				modalItemOptions: defaultModalItemOptions,
				modalOpen: false,
			});
			/*forwardTo('/order-summary')
			forwardTo('/order-summary', { fromItemDetails: true })*/
		}
	};

	instructionsChange = (event) => this.setState({ instructions: event.target.value });

	closeModal = () =>
		this.setState({ modalOpen: false, modalItemOptions: defaultModalItemOptions, validationErrors: [] }, () => {
			const splitPane = document.querySelector('ion-split-pane');
			if (splitPane) {
				splitPane.classList.remove('blur');
			}
		});
	isStoreOpened = () => {
		const { restaurants } = this.props;
		const allRestaurants = JSON.parse(JSON.stringify(restaurants));
		const filteredRestaurants = allRestaurants.filter((el) => el.name !== 'Vouchers' && !el.is_event_venue && el.is_published);
		const selectedRestaurant = filteredRestaurants[0];
		let currentDay = new Date().getDay();
		if (currentDay === 0) {
			currentDay = 7;
		}
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		let today = days[moment().format('d')];
		const openingTimes = selectedRestaurant.json_opening_time_info.filter((el) => el.day === today)[0];
		if (openingTimes && !Array.isArray(openingTimes.time)) {
			openingTimes.time = [openingTimes.time];
		}
		let label = 'CLOSED';
		if (openingTimes && openingTimes?.active !== false) {
			const current = moment().format('HH-mm').split('-');
			const currentTime = { hour: current[0], minutes: current[1] };
			for (let i = 0; i < openingTimes.time.length; i++) {
				const openingTimesForToday = openingTimes.time[i].split('-').map((time) => {
					return {
						hour: time.split(':')[0].trim(),
						minutes: time.split(':')[1].trim(),
					};
				});
				const startTime = openingTimesForToday[0];
				const closeTime = openingTimesForToday[1];

				if (currentTime.hour < closeTime.hour && currentTime.hour > startTime.hour) {
					label = 'OPEN';
					break;
				} else if (currentTime.hour === closeTime.hour) {
					if (currentTime.minutes === closeTime.minutes) {
						label = 'OPEN';
						break;
					} else if (currentTime.minutes > closeTime.minutes) {
						label = 'OPEN';
						break;
					}
				} else if (currentTime.hour === startTime.hour) {
					if (currentTime.minutes === startTime.minutes) {
						label = 'OPEN';
						break;
					} else if (currentTime.minutes > startTime.minutes) {
						label = 'OPEN';
						break;
					}
				}
			}
		}

		return label;
	};
	getClass = (id) => {
		let backgroundImage;
		switch (id) {
			case 'delivery':
				backgroundImage = 'delivery-Icon';
				break;
			case 'charter-delivery':
				backgroundImage = 'delivery-icon';
				break;
			case 'table':
				backgroundImage = 'table-icon';
				break;
			default:
				backgroundImage = 'collection-icon';
		}
		return backgroundImage;
	};
	onContentScrollHandler() {
		const nameVisible = this.isScrolledIntoView(document.querySelector('.item-details-modal-name'));
		if (this.state.nameVisible !== nameVisible) {
			if (!nameVisible) {
				this.setState({ nameVisible: false });
			} else {
				this.setState({ nameVisible: true });
			}
		}
	}
	isScrolledIntoView(el) {
		var rect = el.getBoundingClientRect();
		var elemTop = rect.top - 50;
		var elemBottom = rect.bottom;
		var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
		return isVisible;
	}

	filterMenu(menu) {
		if (menu && menu.menuEntryGroups) {
			menu.menuEntryGroups = this.filterIkentooMenuItems(menu.menuEntryGroups);
			return menu;
		}
		return menu;
	}
	matchesMenuFilters(item, dietary = this.state.selectedDietary, allergens = this.state.selectedAllergens) {
		const { searchItemsValue } = this.state;
		const selectedDietary = dietary;
		const selectedAllergens = allergens;
		if (!getProductName(item, this.props.profile).toLowerCase().includes(`${searchItemsValue.toLowerCase()}`)) {
			return false;
		}
		const itemDietary = (item.itemRichData?.dietaryFlags || []).map((flag) => flag.standard_name);
		if (!selectedDietary.every((flag) => itemDietary.includes(flag))) {
			return false;
		}
		const itemAllergens = item.itemRichData?.allergenCodes || [];
		return !selectedAllergens.some((code) => itemAllergens.includes(code));
	}
	filterIkentooMenuItems(items) {
		let filteredItems = [];
		items.forEach((item) => {
			if (!item.menuEntry) {
				// break recursion when arrive to the product
				if (this.matchesMenuFilters(item)) {
					filteredItems.push(item);
					return [item];
				} else {
					return [];
				}
			} else {
				const len = (item.menuEntry || []).length;
				if (len > 0) {
					const newFilteredItems = this.filterIkentooMenuItems(item.menuEntry);
					if (newFilteredItems.length > 0) {
						item.menuEntry = newFilteredItems;
						filteredItems.push(item);
					}
				}
			}
		});

		return filteredItems;
	}
	filterMenuItems = (value) => {
		this.setState({ searchItemsValue: value }, () => {
			const menu = JSON.parse(JSON.stringify(this.state.originalMenu));
			const filtered = this.filterMenu(menu);
			this.setState({ ikentooMenu: filtered }, () => {
				let menuRefs = this.menuRefs(this.state.ikentooMenu);
				this.setState({ menuRefs });
			});
		});
	};
	getAllergenLabel = (code) => {
		const [label] = parseAllergenData(this.props.profile, { itemRichData: { allergenCodes: [code] } }, this.props.allergens);
		return capitalize(`${label ?? code}`.toLowerCase().replace(/_/g, ' '));
	};
	getDietaryLabel = (flag) => capitalize(flag.toLowerCase().replace(/_/g, ' '));
	hasSelectedFilters = () => this.state.selectedDietary.length > 0 || this.state.selectedAllergens.length > 0;
	selectedFiltersCount = () => this.state.selectedDietary.length + this.state.selectedAllergens.length;
	hasActiveMenuFilters = () => this.state.searchItemsValue !== '' || this.hasSelectedFilters();
	openFilterModal = () => {
		this.setState({ filterModalOpen: true, draftDietary: this.state.selectedDietary, draftAllergens: this.state.selectedAllergens });
	};
	toggleMenuFilter = (key, value) => {
		const selected = this.state[key].includes(value) ? this.state[key].filter((el) => el !== value) : [...this.state[key], value];
		this.setState({ [key]: selected });
	};
	applyMenuFilters = () => {
		this.setState({ selectedDietary: this.state.draftDietary, selectedAllergens: this.state.draftAllergens, filterModalOpen: false }, () => this.filterMenuItems(this.state.searchItemsValue));
	};
	clearMenuFilters = () => {
		this.setState({ draftDietary: [], draftAllergens: [], selectedDietary: [], selectedAllergens: [] }, () => this.filterMenuItems(this.state.searchItemsValue));
	};
	backHandler = () => forwardTo(`${Basket.getDeliveryOption().route}`, { saveOrderData: true });
	handleAlergens = (allergens) => {
		this.setState({ allergens })
	}

	getTextWidth = (text) => {
		const canvas = document.createElement("canvas");
		const context = canvas.getContext("2d");
		context.font = '16px Arial'
		const width = context.measureText(text).width;
		return width + 25
	}
	renderCategories(__, categories, hasMenuFilterOptions) {
		const { selectedCategory } = this.state;
		const categoresToDisplay = []
		const maximumWindowWidth = parseInt(this.props.clientStyles.maximumWindowWidth?.replace('px'))
		let displayWidth = window.innerWidth
		if (window.innerWidth >= maximumWindowWidth) {
			displayWidth = maximumWindowWidth
		}
		const categoriesBar = document.querySelector('.order-categories-inline')
		const sidePadding = categoriesBar ? parseFloat(getComputedStyle(categoriesBar).paddingLeft) || 16 : 16
		const searchWidth = 24
		const filterWidth = hasMenuFilterOptions ? this.getTextWidth(__('Filter')) + 19 + 15 : 0
		const moreWidth = this.getTextWidth(__('More')) + 19
		const categoryWidths = categories.map(category => this.getTextWidth(Basket.getCategoryName(category, this.props.profile)))
		const totalCategoriesWidth = categoryWidths.reduce((acc, width) => acc + width, 0)
		let availableWidth = displayWidth - 2 * sidePadding - searchWidth - filterWidth
		if (totalCategoriesWidth >= availableWidth) {
			availableWidth = availableWidth - moreWidth
		}
		const categoriesDropdown = []
		let categoriesWidth = 0
		for (let i = 0; i < categories.length; i++) {
			categoriesWidth = categoriesWidth + categoryWidths[i]
			if (categoriesWidth < availableWidth) {
				categoresToDisplay.push(categories[i])
			} else {
				categories[i].index = i
				categoriesDropdown.push(categories[i])
			}
		}
		return (
			<>
				<div>
					{categoresToDisplay.map((category, index) => {
						return (
							<IonButton
								key={index}
								size="small"
								fill="clear"
								className={
									selectedCategory === index
										? 'category-button active'
										: 'category-button'
								}
								onClick={() => this.scrollTo(`${category.name}_${index}`, index)}
							>
								{Basket.getCategoryName(category, this.props.profile)}
							</IonButton>
						);
					})}
				</div>
				{categoriesDropdown.length > 0 &&
					<div>
						<IonButton
							id='more_btn'
							size="small"
							fill="clear"
							className={`${this.state.categoryDropdownVisible ? 'show-more-btn-active' : ''} show-more-btn`}
							onClick={() => this.setState({ categoryDropdownVisible: !this.state.categoryDropdownVisible })}
						>
							<NormalText >{__('More')}</NormalText>
							<IonIcon style={{ height: '15px', width: '15px', marginLeft: '4px' }}  icon={chevronDown} />
						</IonButton>

						{this.state.categoryDropdownVisible &&
							<IonPopover showBackdrop={false} trigger={`more_btn`} isOpen={this.state.categoryDropdownVisible} onDidDismiss={() => this.setState({ categoryDropdownVisible: false })}>
								<IonContent className='navigation-content'>
									{categoriesDropdown.map((category, index) => {

										return (
											<IonItem key={`category_${index}`} lines='none'>
												<NormalText
													className={`label-color ${category?.index == selectedCategory ? 'active' : ""}`}
													onClick={() => this.scrollTo(`${category?.name}_${category?.index}`, category?.index)}
												>
													{Basket.getCategoryName(category, this.props.profile)}
												</NormalText>
											</IonItem>
										);
									})}

								</IonContent>
							</IonPopover>
							// <div className={`additional-categories ${categoriesDropdown.map(el => el.index).includes(selectedCategory) ? 'active' : ''}`}>
							// 	<div>
							// 		{categoriesDropdown.map((category, index) => {

							// 			return (
							// 				<NormalText
							// 					color='dark'
							// 					className={`block secondary-font pointer ${category.index == selectedCategory ? 'active' : ""}`}
							// 					onClick={() => this.scrollTo(`${category.name}_${category.index}`, category.index)}
							// 				>
							// 					{Basket.getCategoryName(category, this.props.profile)}
							// 				</NormalText>
							// 			);
							// 		})}
							// 	</div>
							// </div>
						}
					</div>
				}
			</>


		)
	}
	render() {
		const { __, profile, history, restaurants, ikentooMenuError } = this.props;
		const { selectedCategory, ikentooMenu, modalOpen, modalItem, menuHero, description, allergens } = this.state;
		let categories = !isEmptyObject(ikentooMenu) ? ikentooMenu.menuEntryGroups : [];
		const menuItems = Basket.flattenMenuItems(this.state.originalMenu?.menuEntryGroups).filter((item) => ['menuItem', 'menuDeal'].includes(item['@type']));
		const menuDietary = [...new Set(menuItems.map((item) => item.itemRichData?.dietaryFlags || []).flat().map((flag) => flag.standard_name).filter(Boolean))];
		const menuAllerges = [...new Set(menuItems.map((item) => item.itemRichData?.allergenCodes || []).flat().filter(Boolean))];
		const hasMenuFilterOptions = !getConfig().flags.removeFiltersFromMenu && (menuDietary.length > 0 || menuAllerges.length > 0);
		const draftMatchesCount = menuItems.filter((item) => this.matchesMenuFilters(item, this.state.draftDietary, this.state.draftAllergens)).length;
		let modalItemImage = modalItem && modalItem.itemRichData && modalItem.itemRichData.squareImageUrl ? modalItem.itemRichData.squareImageUrl : '';
		const isLogoClicked = history?.location?.state?.isLogoClicked;
		if (modalItemImage && modalItemImage.indexOf('http://') !== -1) {
			modalItemImage = modalItemImage.replace(/http:\/\//g, 'https://');
		}
		const hasNutritionInfo = getConfig().flags.hasNutritionTab || modalItem?.itemRichData?.calories || modalItem?.itemRichData?.dietaryFlags?.length > 0 || (getConfig().flags.hasItemIngredients && modalItem?.itemRichData?.ingredients?.length > 0)
		const filteredRestaurants = restaurants.filter((restaurant) => restaurant.name !== 'Vouchers' && !restaurant.is_event_venue && restaurant.is_published);
		return (
			<Loading transparent>
				<Layout
					noPadding
					scrollY={false}
					backHandler={this.backHandler}
					selectCategoryOnScroll={this.selectCategoryOnScroll}
				>
					{getConfig().flags.removeSidebar ?
						<div className='order-list-full order-list'>

							<div className="order-categories order-categories-inline" >
								{Basket.has_multi_basket &&
									<IonButton onClick={() => this.backHandler()} fill='clear'><IonIcon icon={chevronBack} /></IonButton>
								}
								{!ikentooMenuError ?
									<>
										{!this.state.searchBoxOpen &&
											<>
												{categories?.length > 0 ? (
													<div className="order-categories-inner order-categories-inner-inline">
														{this.renderCategories(__, categories, hasMenuFilterOptions)}
													</div>
												) : this.hasActiveMenuFilters() ? null : (
													<div className="order-categories-inner order-categories-inner-inline">
														<IonButton
															size="small"
															fill="clear"
														>
															<NormalText className="label-color">{__('No items found')}</NormalText>

														</IonButton>
													</div>
												)}
											</>
										}

										<div className="desktop-search-box-wrapper" style={this.state.searchBoxOpen ? { flexDirection: 'row-reverse', width: '100%', justifyContent: 'space-between' } : {}}>

											{!this.state.searchBoxOpen && hasMenuFilterOptions && (
												<div className="menu-filter-trigger" onClick={this.openFilterModal}>
													<IonIcon icon={filterOutline}></IonIcon>
													<NormalText>{__('Filter')}</NormalText>
													{this.hasSelectedFilters() && <div className="menu-filter-badge">{this.selectedFiltersCount()}</div>}
												</div>
											)}
											<IonIcon onClick={() => {
												this.setState({ searchBoxOpen: !this.state.searchBoxOpen }, () => {
													if (this.state.searchBoxOpen) {
														setTimeout(() => {
															document.querySelector('#products_search').setFocus()
														}, 0);
													} else {
														this.filterMenuItems('')
													}
												});

											}} icon={this.state.searchBoxOpen ? closeOutline : search}></IonIcon>
											{this.state.searchBoxOpen &&
												<IonItem lines='none'>
													<IonInput autofocus={true} id='products_search' placeholder={__('Search products')} value={this.state.searchItemsValue} onIonInput={(e) => this.filterMenuItems(e.target.value)} />
												</IonItem>
											}

										</div>
									</>
									:
									<div className="order-categories-inner order-categories-inner-inline">
										<IonButton
											size="small"
											fill="clear"
										>
											<NormalText className="label-color">{__('No items found')}</NormalText>

										</IonButton>
									</div>
								}

							</div>
							{!ikentooMenuError && categories?.length === 0 && this.hasActiveMenuFilters() &&
								<div className="order-content order-content-inline" >
									<NoFilterResults openFilters={this.openFilterModal} />
								</div>
							}
							{!ikentooMenuError && !(categories?.length === 0 && this.hasActiveMenuFilters()) &&
								<div className="order-content order-content-inline" >
									<OrderList
										categoryHeight={this.state.categoryHeight}
										showModal={this.showModal}
										category={!isEmptyObject(ikentooMenu) ? ikentooMenu : null}
										menuRefs={this.state.menuRefs ? this.state.menuRefs : []}
									/>
								</div>
							}

						</div>
						: <>
							{!ikentooMenuError ?
								<>
									{!isDefined(ikentooMenu) && !isEmptyObject(ikentooMenu) && !ikentooMenu ? null : (
										<div className={'order-list' + (Basket.itemsCount() < 1 || Basket.getDeliveryOption()?.id === 'gift-vouchers' ? ' order-list-full' : '')}>
											{ikentooMenu && ikentooMenu.menuName && ikentooMenu.menuName.indexOf('Default') === -1 && !isLogoClicked ? null : (
												<div className="web-only order-list-heading">
													<div className="order-list-restaurant-image">
														<div className="order-list-restaurant-bg" style={{ backgroundImage: `url(${menuHero})` }}></div>
													</div>
													<div className="restaurant-info-banner">
														<img alt="client logo" className="client-logo" src={this.state.mainLogo} />
														<div style={{ flex: 1 }}>
															<NormalText className="block">{description?.replace(/(<([^>]+)>)/gi, '')}</NormalText>
														</div>
														{filteredRestaurants.length > 0 && (
															<div className="restaurant-info-delivery-options">
																<div>
																	<StrongText className="block">{this.isStoreOpened()}</StrongText>
																	<NormalText>{filteredRestaurants[0].name}</NormalText>
																</div>
																<div className="icons-wrapper">
																	{getConfig().delivery.map((d, index) =>
																		d.isRemoved ? null : <div key={index} className={this.getClass(d.id)} onClick={() => this.setDeliveryOption(d)}></div>,
																	)}
																</div>
															</div>
														)}
													</div>
												</div>
											)}
											<div className="order-categories ">
												<div className="search-box-wrapper">
													<Title style={{ margin: 0 }}>{__('Select items')}</Title>
													<div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
														<div className="search-box">
															<IonIcon color="secondary" icon={search}></IonIcon>
															<IonInput placeholder={__('Search products')} value={this.state.searchItemsValue} onIonInput={(e) => this.filterMenuItems(e.target.value)} />
															<IonIcon onClick={() => this.setState({ searchItemsValue: '' })} className="reset-icon" color="secondary" icon={close}></IonIcon>
														</div>
														{hasMenuFilterOptions && (
															<div className="menu-filter-trigger" onClick={this.openFilterModal}>
																<IonIcon icon={filterOutline}></IonIcon>
																<NormalText>{__('Filter')}</NormalText>
																{this.hasSelectedFilters() && <div className="menu-filter-badge">{this.selectedFiltersCount()}</div>}
															</div>
														)}
													</div>
												</div>
												{categories?.length > 0 ? (
													<div className="order-categories-inner ">
														{(categories || []).map((category, index) => {
															return (
																<IonButton
																	key={index}
																	size="small"
																	fill='clear'
																	className={selectedCategory === index ? 'category-button active' : 'category-button'}
																	onClick={() => this.scrollTo(`${category.name}_${index}`, index)}
																>
																	<StrongText>{Basket.getCategoryName(category, this.props.profile)}</StrongText>
																</IonButton>
															);
														})}
													</div>
												) : this.hasActiveMenuFilters() ? null : (
													<NormalText className="">{__('No items found')}</NormalText>
												)}
											</div>
											<div className="order-content" style={{ paddingLeft: '50px' }}>
												{categories?.length === 0 && this.hasActiveMenuFilters() ? (
													<NoFilterResults openFilters={this.openFilterModal} />
												) : (
													<OrderList
														categoryHeight={this.state.categoryHeight}
														showModal={this.showModal}
														category={!isEmptyObject(ikentooMenu) ? ikentooMenu : null}
														menuRefs={this.state.menuRefs ? this.state.menuRefs : []}
													/>
												)}
											</div>
										</div>
									)}
								</> :
								<div style={{ height: '100%' }} className={'order-list' + (Basket.itemsCount() < 1 || Basket.getDeliveryOption()?.id === 'gift-vouchers' ? ' order-list-full' : '')}>

									<div style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: '50px' }} className="order-content" >
										<NormalText className="">{__('No items found')}</NormalText>

									</div>

								</div>}
							{Basket.getDeliveryOption().id !== 'gift-vouchers' && (
								<>
									{Basket.itemsCount() > 0 ? (
										<div className="order-summary-sidebar">
											<OrderSummary />
										</div>
									) : null}
								</>
							)}
						</>
					}


				</Layout>
				{hasMenuFilterOptions && <Modal
					className="menu-filter-modal"
					isOpen={this.state.filterModalOpen}
					onDidDismiss={() => this.setState({ filterModalOpen: false })}
				>
					<div className="menu-filter-modal-content">
						<Title>{__('Filter')}</Title>
						<div className="search-filters-scroll">
							{menuDietary.length > 0 && (
								<>
									<Spacer size={3} />

									<StrongText className="search-filters-title text-to-update">{__('Dietary')}</StrongText>
									<div className="search-filters-pills">
										{menuDietary.map((flag) => (
											<IonButton
												key={flag}
												size="small"
												fill="clear"
												className={`search-filter-pill ${this.state.draftDietary.includes(flag) ? 'active' : ''}`}
												onClick={() => this.toggleMenuFilter('draftDietary', flag)}
											>
												<NormalText>{__(this.getDietaryLabel(flag))}</NormalText>
											</IonButton>
										))}
									</div>
									<Spacer size={1} />
								</>
							)}
							{menuAllerges.length > 0 && (
								<>
									<Spacer size={3} />
									<StrongText className="search-filters-title text-to-update">{__('Allergens to avoid')}</StrongText>
									<div className="search-filters-pills">
										{menuAllerges.map((code) => (
											<IonButton
												key={code}
												size="small"
												fill="clear"
												className={`search-filter-pill ${this.state.draftAllergens.includes(code) ? 'active' : ''}`}
												onClick={() => this.toggleMenuFilter('draftAllergens', code)}
											>
												<NormalText>{__(this.getAllergenLabel(code))}</NormalText>
											</IonButton>
										))}
									</div>
								</>
							)}
						</div>
						<Spacer size={5} />
						<div className="search-filters-actions">
							<IonButton className="button-uppercase" expand="block" fill="outline" color="primary" onClick={this.clearMenuFilters}>
								{__('Clear all')}
							</IonButton>
							<IonButton className="button-uppercase" expand="block" color="primary" onClick={this.applyMenuFilters}>
								{draftMatchesCount === 1 ? __('Show {count} result', { count: draftMatchesCount }) : __('Show {count} results', { count: draftMatchesCount })}
							</IonButton>
						</div>
					</div>
				</Modal>}
				{modalOpen && (
					<Modal className="item-details-modal" isOpen={modalOpen} onDidDismiss={() => this.closeModal()}>
						{modalItem ? (
							<>
								<div className='item-details-wrapper'>
									<div ref={this.scrollableWrapperRef} className='item-details scrollable-wrapper'>
										{!getConfig().flags.removeMenuImages &&
											<>
												{modalItemImage && modalItemImage !== '' ? (
													<img className='modal-item-details-image' style={{ objectFit: 'cover' }} alt="modal item" src={modalItemImage} />
												) : (
													<img
														className='modal-item-details-image'
														style={{ objectFit: 'contain' }}
														alt="modal item"
														src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image}
													/>
												)}
											</>}

										<ScrollableTabs
											parent={this.scrollableWrapperRef}
											tabs={
												[
													{
														title: 'Description',
														content: (
															<>
																<Title>
																	{__(getProductName(modalItem, this.props.profile))}
																</Title>
																{formatPrice(modalItem.productPrice) &&
																	<StrongText>{formatPrice(modalItem.productPrice)}</StrongText>
																}
																{getProductDescription(modalItem, profile) !== '' &&
																	<>
																		<Spacer size={2} />
																		<NormalText
																			className="block item-details-card-description"
																			dangerouslySetInnerHTML={{
																				__html: getConfig().flags.removeHTMLTagsOnProductDescription ? getProductDescription(modalItem, profile) : getProductDescription(modalItem, profile).replace(/(<([^>]+)>)/gi, ''),

																			}}
																		></NormalText>
																	</>
																}
																{allergens.length > 0 && !hasNutritionInfo ? (
																	<>
																		<Spacer size={2} />
																		<SmallText className='primary-color'>
																			{allergens.map(el => __(capitalize(el))).join(', ')}
																		</SmallText>
																	</>
																) : null}
																{getConfig()?.customExternalLinks?.product && !hasNutritionInfo &&
																	<>
																		<Spacer size={2} />
																		<IonButton
																			onClick={() => {
																				openExternalLink(getConfig().customExternalLinks.product?.url)
																			}}
																			color="secondary"
																			className=" link"
																		>
																			{__(getConfig().customExternalLinks.product?.title)}
																		</IonButton>
																		<Spacer />
																	</>
																}
																{getConfig().frenchDisclaimer?.disclaimerImage && !hasNutritionInfo && (
																	<div className="disclaimer-wrapper">
																		<img className='disclaimer-image' src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
																	</div>
																)}
															</>
														)
													},
													{
														...(hasNutritionInfo &&
														{
															title: 'Nutrition & Safety',
															content: (
																<div style={{ display: 'grid', gap: 'var(--spacer-2)' }}>
																	{allergens.length > 0 ? (
																		<div>

																			<StrongText>{__('Allergens')}</StrongText>

																			<SmallText className='primary-color'>
																				{allergens.map(el => __(capitalize(el))).join(', ')}
																			</SmallText>

																		</div>
																	) : null}
																	{modalItem.itemRichData?.dietaryFlags?.length > 0 ? (
																		<div>
																			<StrongText>{__('Dietary flags')}</StrongText>
																			<SmallText className='primary-color'>
																				{modalItem.itemRichData?.dietaryFlags.map(el => __(capitalize(el.standard_name.toLowerCase().replace(/_/g, ' ')))).join(', ')}
																			</SmallText>

																		</div>
																	) : null}
																	{modalItem.itemRichData?.ingredients?.length > 0 && getConfig().flags.hasItemIngredients ? (
																		<div>

																			<StrongText>{__('Ingredients')}</StrongText>
																			<SmallText className='primary-color'>
																				{modalItem.itemRichData?.ingredients.map(el => __(capitalize(el.standard_name.toLowerCase().replace(/_/g, ' ')))).join(', ')}
																			</SmallText>
																		</div>
																	) : null}
																	{modalItem.itemRichData?.calories ? (
																		<div>
																			<StrongText>{__('Calories')}</StrongText>
																			<SmallText className='primary-color'>
																				{`${modalItem.itemRichData?.calories} ${__('kcal')}`}
																			</SmallText>
																		</div>
																	) : null}
																	{getConfig()?.customExternalLinks?.product &&
																		<div>
																			<IonButton
																				onClick={() => {
																					openExternalLink(getConfig().customExternalLinks.product?.url)
																				}}
																				color="secondary"
																				className=" link"
																			>
																				{__(getConfig().customExternalLinks.product?.title)}
																			</IonButton>
																			<Spacer />
																		</div>
																	}
																	{getConfig().frenchDisclaimer?.disclaimerImage && (
																		<div className="disclaimer-wrapper">
																			<img className='disclaimer-image' src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
																		</div>
																	)}
																</div>
															)
														}

														)
													}
												]
											}
										/>
									</div>
									<div className='item-modifiers item-details-content'>
										<Title style={{ paddingLeft: 'var(--ion-padding-page)' }}>{__('Options')}</Title>
										<ItemDetailsRaw handleAlergens={this.handleAlergens} item={modalItem} profile={profile} modalOpen={modalOpen} closeModal={this.closeModal} />

									</div>

								</div>

							</>
						) : null}
					</Modal>
				)}

			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { clientProfile, clientProfileUpdated, clientStyles } = state.common;
	const { profile, auth } = state.profile;
	const { restaurants, ikentooMenu, defaultMenu, restaurantsUpdated, ikentooMenuError, allergens } = state.restaurants;

	const { scrollTop } = state.orders;
	return {
		auth,
		restaurants: restaurants || [],
		ikentooMenu: ikentooMenu || {},
		defaultMenu: defaultMenu || {},
		basketUpdated: state.orders.basketUpdated,
		scrollTop,
		storedItemWeb: state.orders.storedItemWeb,
		restaurantsUpdated,
		clientProfile,
		clientProfileUpdated,
		profile,
		ikentooMenuError,
		clientStyles,
		allergens

	};
};

export default connect(stateToProps)(withTranslation(OrderPage));
